import * as React from "react";
import { ItemLabelText, ItemValueText } from "@shared/common";

export interface IKaartItem {
  label: string;
  value: string | JSX.Element;
  id: string;
}

interface IKaartItemProps {
  item: IKaartItem;
}
export const KaartItem = (props: IKaartItemProps) => {
  return (
    <li className="kaart-group-item" id={props.item.id} key={props.item.id}>
      <ItemLabelText label={props.item.label} />
      {typeof props.item.value === "string" && (
        <ItemValueText className="item-value" value={props.item.value} />
      )}

      {React.isValidElement(props.item.value) && <span className="item-value">{props.item.value}</span>}
    </li>
  );
};
